import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { getSession, isRealObject, processEmail, processInt, processNum, processStrWithSpace, valdiatePage } from "../../global";
import { getSubAccountLocations, getAreas } from '../../services/userservice';
import { getServiceGuide, save, getCustomerInfo, getTarrif } from '../../services/bookingservice';
import './retailbooking.css';
import MemoDestinationsDDL from '../../components/memoDestinationsDDL';
import { setLoading } from '../../redux/appSlice'
import { useDispatch, useSelector } from "react-redux";

const RetailBooking = () => {
    const dispatch = useDispatch();
    const { loading, userInfo, destinations, subaccounts, types, services } = useSelector(state => state.appData);
    const d = {
        cn: '',
        cnType: '12',
        consignee: '',
        consigneeAddress: '',
        consigneePhone: '',
        consigneeEmail: '',
        destination: '',
        area: '',
        //destinationName: '',
        pcs: '1',
        serviceType: '',
        weight: '',
        productDetails: '',
        remarks: '',
        refNo: '',
        codAmount: '0',
        shs: true,
        departmentCostCenter: '',
        locationId: '',
        //subAccountId: '',
        subAccountId: '',
        autoCN: null,
        //isCod: types && types.length > 0 ? types[0].value == 1 : null,
        isCod: null,
        accountNo: '',
        lat: '',
        long: '',
        branch: '',
        w: '',
        l: '',
        h: '',
        denseWeight: '',
        rt: null,
        totalAmount: '0',
        gst: '0',
        chargeAmount: '0'
    };

    const [data, setData] = useState(d);
    const [serviceGuide, setServiceGuide] = useState(null);
    const [locations, setLocations] = useState([]);
    const [areas, setAreas] = useState([]);
    const destRef = useRef(null);
    const [sr, setSr] = useState([]);


    const history = useHistory();


    useEffect(() => {
        if (!valdiatePage('/booking')) {
            history.push('/login');
        }
    }, []);

    useEffect(() => {
        if (data.destination) {
            getAreas(data.destination).then(rs => {
                if (rs.sts == 0) {
                    setAreas(rs.data);
                } else {
                    setAreas([]);
                }
            });
        } else {
            setAreas([]);
        }
    }, [data.destination]);

    useEffect(() => {
        if (data.branch && data.destination) {
            const z = {
                branchCode: data.branch,
                //destination: data.destinationName || destinations.find(x => x.value == data.destination).text,
                destination: destinations.find(x => x.value == data.destination).text,
                type: data.isCod ? 1 : 0
            }
            getServiceGuide(z).then(rs => {
                if (rs.ok)
                    setServiceGuide(rs.data);
                else
                    setServiceGuide(null);
            })
        }
    }, [data.branch, data.destination]);

    useEffect(() => {
        const dw = +data.denseWeight;
        const w = ((+data.l) * (+data.w) * (+data.h)) / 5000;
        if (w > dw)
            updateData('weight', w);
        else
            updateData('weight', dw);
    }, [data.l, data.w, data.h, data.denseWeight]);

    useEffect(() => {
        const load = async () => {
            const iscod = types && types.length > 0 ? types[0].value == 1 : null;
            const dsa = subaccounts.find(x => x.isCod == iscod && x.isDefault);
            const d = { ...data, accountNo: dsa.accountNo, isCod: iscod, subAccountId: '', locationId: '', branch: '', autoCN: null };
            if (dsa) {
                d.subAccountId = dsa.id;
                d.autoCN = dsa.autoCN;
                // const locs = await getLocations(userInfo.id, dsa.accountNo);
                const locs = await getSubAccountLocations(userInfo?.id, dsa.id);
                if (locs) {
                    setLocations(locs);
                    const dl = locs.find(x => x.isDefault);
                    if (dl) {
                        d.locationId = dl.value;
                        d.branch = dl.branch;
                    }
                }
            }
            setData(d);
        }

        load();
    }, []);

    const validate = (u) => {
        //Consignee Name is Required
        //Consignee Address is Required
        //Consignee Mobile No is Required
        //Destination City is Required
        //Pieces is Required
        //Ref No is Required
        //Service is Required
        //Consignee Name Length Must be Less than or Equals to 50
        //Consignee Address Length Must be Less than or Equals to 255
        //Consignee Email Length Must be Less than or Equals to 50
        //Product Detail Length Must be Less than or Equals to 600
        //Ref No Length Must be Less than or Equals to 50
        //Pieces Must be Greater than to 0
        //Weight Must be Greater than to 0
        //Max Alowed Weight Exceeds (9999)
        //Max Alowed Weight Exceeds (99)
        //COD amount must be greater than 0
        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }

        if (!data.locationId) {
            alert('Location is required');
            return false;
        }

        if (data.autoCN == false && !data.cn) {
            alert('Consignment No is required');
            return false;
        }


        if (!data.consignee || data.consignee.trim() === '') {
            alert('Consignment Name is required');
            return false;
        }

        if (data.isCod) {
            if (!data.consigneePhone) {
                alert('Consignment Phone is required');
                return false;
            } else {
                if (data.consigneePhone.length < 11) {
                    alert('Consignment Phone is Invalid');
                    return false;
                }
            }
        }

        if (data.consigneeEmail.trim() && !data.consigneeEmail.includes('@')) {
            alert('Consignment Email is invalid');
            return false;
        }

        if (!data.consigneeAddress || data.consigneeAddress.trim() === '') {
            alert('Consignment Address is required');
            return false;
        }


        if (!data.serviceType) {
            alert('Select Service Type');
            return false;
        }

        if (!data.destination) {
            alert('Destination is required');
            return false;
        }

        // if (data.isCod && !userInfo.isZeroCodAllowed) {
        //     if (!data.codAmount || data.codAmount <= 0) {
        //         alert('Cod Amount must be greater than 0');
        //         return false;
        //     } else if (data.codAmount > 99999) {
        //         alert('Cod Amount must be less than 99999');
        //         return false;
        //     }
        // }

        if (data.isCod) {

            if (!userInfo.isZeroCodAllowed) {
                if (+data.codAmount <= 0) {
                    alert('Cod Amount must be greater than 0');
                    return false;
                }
            }

            if (+data.codAmount > 99999) {
                alert('Cod Amount must be less than 99999');
                return false;
            }
        }



        if (!data.weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {
            const w = data.isCod ? 99 : 9999;
            if (data.weight > w) {
                alert('Weight is greater than ' + w);
                return false;
            }
        }

        if (!data.pcs || data.pcs <= 0) {
            alert('Pieces is required');
            return false;
        }


        if (data.isCod && !data.refNo) {
            alert('Ref No is required');
            return false;
        }

        if (+data.totalAmount <= 0 || +data.gst <= 0) {
            alert('Get tarrif first');
            return false;
        }

        return true;
    }

    const validateTarrif = () => {
        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }
        if (!data.locationId) {
            alert('Location is required');
            return false;
        }
        if (!data.destination) {
            alert('Destination is required');
            return false;
        }
        if (!data.serviceType) {
            alert('Select Service Type');
            return false;
        }
        if (!data.weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {
            const w = data.isCod ? 99 : 9999;
            if (data.weight > w) {
                alert('Weight is greater than ' + w);
                return false;
            }
        }
        return true;
    }

    const reset = () => {
        setData(prev => {
            return { ...d, subAccountId: prev.subAccountId, locationId: prev.locationId, isCod: prev.isCod, autoCN: prev.autoCN, branch: prev.branch, serviceType: prev.serviceType };
        });
        setServiceGuide(null);
        destRef.current.selectedIndex = 0;
    }

    const onSave = async () => {
        const u = getSession('userInfo');
        if (validate(u)) {
            const z = {
                cn: data.autoCN ? null : data.cn,
                cnType: data.cnType,
                consignee: data.consignee,
                consigneeAddress: data.consigneeAddress,
                consigneePhone: data.consigneePhone,
                consigneeEmail: data.consigneeEmail,
                destination: data.destination,
                area: data.area,
                pcs: data.pcs,
                serviceType: data.serviceType,
                weight: data.weight,
                productDetails: data.productDetails,
                remarks: data.remarks,
                refNo: data.refNo,
                codAmount: data.isCod ?  data.codAmount ? data.codAmount : null : 0,
                shs: data.shs,
                departmentCostCenter: data.isCod ? null : data.departmentCostCenter,
                user: {
                    id: userInfo.id,
                    isDuplicateOrderAllowed: userInfo.isDuplicateOrderAllowed
                },
                locationId: data.locationId,
                subAccountId: data.subAccountId,
                autoCN: data.autoCN,
                accountNo: data.accountNo,
                departmentOrCostCenter: data.departmentOrCostCenter,
                serviceAreaType: Number(data.serviceAreaType),
                lat: Number(data.lat),
                long: Number(data.long),
                totalAmount: data.totalAmount,
                gst: data.gst
            };
            dispatch(setLoading({ data: true }));
            const rs = await save(z);
            dispatch(setLoading({ data: false }));
            alert(rs.msg);
            if (rs.ok) {
                reset();
            }
        }
    }

    const onTarrifLoad = async () => {
        if (validateTarrif()) {
            const tarrifPayload = {
                account: data.accountNo,
                origin: data.branch,
                destination: data.destination,
                serviceType: data.serviceType,
                weight: data.weight,
            };
            dispatch(setLoading({ data: true }));
            const rs = await getTarrif(tarrifPayload);
            dispatch(setLoading({ data: false }));
            if (rs.ok && isRealObject(rs.data)) {
                const { amount, gst } = rs.data
                if (amount && gst) {
                    setData(prevState => { return { ...prevState, totalAmount: amount, gst: gst, chargeAmount: amount + gst }; })
                } else {
                    alert(rs.data.msg)
                }
            } else {
                alert(rs.msg);
            }
        }
    }

    const updateData = (key, val) => setData(prevState => { return { ...prevState, [key]: val }; });

    const onCNBlur = (e) => {
        if (data.locationId) {
            const val = e.target.value;
            if (val) {
                const num = Number(val);
                const sequnce = getSession('sequences').filter(x => x.locationId == data.locationId)[0];
                const start = Number(sequnce.sequenceStart);
                const end = Number(sequnce.sequenceEnd);
                if (!(num >= start && num <= end)) {
                    alert('Invalid Consignment No');
                    setData({ ...data, cn: '' });
                }
            }
        } else {
            alert('Select Location');
            setData({ ...data, cn: '' });
        }
    }

    const onConsigneePhoneBlur = async (e) => {
        const val = e.target.value;
        if (val) {
            dispatch(setLoading({ data: true }));
            const rs = await getCustomerInfo(val);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setData(prev => {
                    return {
                        ...prev,
                        consignee: rs.data.name,
                        consigneeAddress: rs.data.address,
                        rt: rs.data.returnTendency,
                        destination: rs.data.destinationId,
                        lat: rs.data.lat,
                        long: rs.data.long
                    }
                })
                destRef.current.value = rs.data.destinationId;
                const z = destinations.find(x => x.value == rs.data.destinationId);
                setSr(services.filter(x => z.isExpressCargo ? true : x !== 'Express Cargo'));
            }
        }
    }

    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>Retail Booking</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-4 col-xl-3">
                    <label>Type</label>
                    <select className="form-select" value={data.isCod ? 1 : 0} onChange={async (e) => {
                        const iscod = e.target.value == 1;
                        const dsa = subaccounts.find(x => x.isCod == iscod && x.isDefault);
                        const d = { ...data, isCod: iscod, locationId: '', branch: '', subAccountId: '', autoCN: null };
                        if (dsa) {
                            d.subAccountId = dsa.id;
                            d.autoCN = dsa.autoCN;
                            // const locs = await getLocations(userInfo.id, dsa.accountNo);
                            const locs = await getSubAccountLocations(userInfo.id, dsa.id);
                            if (locs) {
                                setLocations(locs);
                                const dl = locs.find(x => x.isDefault);
                                if (dl) {
                                    d.locationId = dl.value;
                                    d.branch = dl.branch;
                                }
                            }
                        } else {
                            setLocations([]);
                        }
                        setData(d);
                    }}>
                        {
                            types.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-4 col-xl-3">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId}
                        onChange={async (e) => {
                            const val = e.target.value;
                            const autoCn = e.target[e.target.selectedIndex].getAttribute('data-autocn');
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            const d = { ...data, subAccountId: val, locationId: '', branch: '', autoCN: autoCn ? autoCn === 'true' : null, accountNo: accno };
                            if (val) {
                                //const locs = await getLocations(userInfo.id, accno)
                                const locs = await getSubAccountLocations(userInfo.id, val)
                                if (locs) {
                                    setLocations(locs);
                                    const dl = locs.find(x => x.isDefault);
                                    if (dl) {
                                        d.locationId = dl.value;
                                        d.branch = dl.branch
                                    }
                                }
                            } else {
                                setLocations([]);
                            }
                            setData(d);
                        }}>
                        <option value="" data-autocn={null} data-accno="">Select Sub Account</option>
                        {
                            subaccounts.filter(x => x.isCod == data.isCod).map((x, index) => <option key={index} value={x.id} data-autocn={x.autoCN} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-4 col-xl-3">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => {
                        const val = e.target.value;
                        const branch = e.target[e.target.selectedIndex].getAttribute('data-branch');
                        setData({ ...data, locationId: val, branch: branch });
                    }}>
                        <option value="" data-branch={""}>Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value} data-branch={x.branch}>{x.text}</option>)
                        }
                    </select>
                </div>
                {
                    data.autoCN == false && <div className="col-lg-4 col-xl-3">
                        <label>Consignment Number</label>
                        <input type="text" maxLength={15} className="form-control" onInput={processInt} value={data.cn} onChange={(e) => updateData('cn', e.target.value)} onBlur={onCNBlur} />
                    </div>
                }
            </div>
            <div className="row mt-3">
                <div className="col-lg-3 col-sm-12">
                    <label>Consignee Phone</label>
                    <input type="text" className="form-control" maxLength={['1m221', '1m222'].includes(data.accountNo.toLowerCase()) ? 20 : 11} value={data.consigneePhone} onInput={processInt} onBlur={onConsigneePhoneBlur} onChange={(e) => updateData('consigneePhone', e.target.value)} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Consignee Name</label>
                    <input type="text" className="form-control" maxLength={50} value={data.consignee} onChange={(e) => updateData('consignee', e.target.value)} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Consignee Email</label>
                    <input type="text" className="form-control" maxLength={50} value={data.consigneeEmail} onInput={processEmail} onChange={(e) => updateData('consigneeEmail', e.target.value)} />
                </div>
                {
                    data.rt && data.rt > 0 &&
                    <div className="col-lg-3 col-sm-12">
                        <label>Return Tendency</label>
                        <p style={{ color: '#f26522' }}>{data.rt}%, customer is likely to accept order</p>
                    </div>
                }
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>Destination</label>
                    <MemoDestinationsDDL destRef={destRef} label="Destination" destinations={destinations} onChange={(e) => {
                        const val = e.target.value;
                        //const name = e.target[e.target.selectedIndex].getAttribute('data-name');
                        const ec = e.target[e.target.selectedIndex].getAttribute('data-ec') === "true";
                        //const br = e.target[e.target.selectedIndex].getAttribute('data-branch');
                        //const uetbranches = [113, 132, 169, 280, 293, 294, 295, 31, 313, 314, 315, 32, 326, 327, 328, 329, 33, 57, 79];

                        // if (uetbranches.includes(+br)) {
                        //     alert('Dear Valued Customer, this is to apprise you that due to urban flooding situation, our services (pickups & deliveries) for Quetta and allied locations will remain suspended, because all transportation links to Quetta are disconnected. Our Customer Service Team will keep you posted as soon as we are confirmed about the situation.');
                        //     destRef.current.value = '';
                        //     return;
                        // }

                        setData(prev => {
                            return { ...prev, destination: val, serviceType: "" };
                        });

                        setSr(services.filter(x => ec ? true : x !== 'Express Cargo'));
                    }} />
                </div>
                <div className="col-lg">
                    <label>Area</label>
                    <select className="form-select" value={data.area} onChange={(e) => updateData('area', e.target.value)}>
                        <option value="">Select Area</option>
                        {
                            areas.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Service Guide</label>
                    {
                        function () {
                            let c = "";
                            if (serviceGuide != null)
                                c = `Type = ${serviceGuide.status}, Additional Charges upto 5KG = ${serviceGuide.addchrgsuptO5KG}, Extra Days = ${serviceGuide.extraDays}`;
                            return <input type="text" className="form-control" value={c} readOnly />
                        }()
                    }
                </div>
                <div className="col-lg">
                    <label>Latitude</label>
                    <input type="text" className="form-control" value={data.lat} onInput={processNum} onChange={(e) => updateData('lat', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Longitude</label>
                    <input type="text" className="form-control" value={data.long} onInput={processNum} onChange={(e) => updateData('long', e.target.value)} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <label>Consignee Address</label>
                    <textarea className="form-control" maxLength={255} value={data.consigneeAddress} onChange={(e) => updateData('consigneeAddress', e.target.value)}></textarea>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>Service Type</label>
                    <select className="form-select" value={data.serviceType} onChange={(e) => updateData('serviceType', e.target.value)}>
                        <option value="">Select Service</option>
                        {
                            sr.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Special Handling</label>
                    <select className="form-select" value={data.cnType} onChange={(e) => updateData('cnType', e.target.value)}>
                        <option value="13">Yes</option>
                        <option value="12">No</option>
                    </select>
                </div>
                <div className="col-lg-7">
                    <div className="row">
                        <div className="col-lg">
                            <label>Dense Weight</label>
                            <input type="text" className="form-control" value={data.denseWeight} onChange={(e) => updateData('denseWeight', e.target.value)} />
                        </div>
                        <div className="col-lg-2">
                            <label>W</label>
                            <input type="text" className="form-control" value={data.w} onChange={(e) => updateData('w', e.target.value)} />
                        </div>
                        <div className="col-lg-2">
                            <label>H</label>
                            <input type="text" className="form-control" value={data.h} onChange={(e) => updateData('h', e.target.value)} />
                        </div>
                        <div className="col-lg-2">
                            <label>L</label>
                            <input type="text" className="form-control" value={data.l} onChange={(e) => updateData('l', e.target.value)} />
                        </div>
                        <div className="col-lg">
                            <label>Pieces</label>
                            <input type="text" className="form-control" maxLength={2} readOnly value={data.pcs} onInput={processInt} onChange={(e) => updateData('pcs', e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-12">
                <div className="row">
                    {
                        data.isCod &&
                        <div className="col-lg-2">
                            <label>COD Amount</label>
                            <input type="text" className="form-control" value={data.codAmount} onInput={processNum} onChange={(e) => updateData('codAmount', e.target.value)} />
                        </div>
                    }
                    <div className="col-lg-2">
                        <label>Customer Ref No</label>
                        <input type="text" className="form-control" maxLength={20} value={data.refNo} onChange={(e) => updateData('refNo', e.target.value)} />
                    </div>
                    <div className="col-lg-2">
                        <label>Total Amount</label>
                        <input type="text" className="form-control" disabled maxLength={20} value={data.totalAmount} onChange={(e) => updateData('totalAmount', e.target.value)} />
                    </div>
                    <div className="col-lg-2">
                        <label>GST</label>
                        <input type="text" className="form-control" disabled maxLength={20} value={data.gst} onChange={(e) => updateData('gst', e.target.value)} />
                    </div>
                    <div className="col-lg-2">
                        <label>Charge Amount</label>
                        <input type="text" className="form-control" disabled maxLength={20} value={data.chargeAmount} onChange={(e) => updateData('chargeAmount', e.target.value)} />
                    </div>
                    <div className="col-lg-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button type="button" className="btn btn-primary" disabled={loading} onClick={onTarrifLoad}>Tarrif</button>
                    </div>
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-6">
                    <label>Product Detail</label>
                    <textarea className="form-control" maxLength={600} value={data.productDetails} onChange={(e) => updateData('productDetails', e.target.value)}></textarea>
                </div>
                <div className="col-6">
                    <label>Remarks</label>
                    <textarea className="form-control" maxLength={600} value={data.remarks} onChange={(e) => updateData('remarks', e.target.value)}></textarea>
                </div>
            </div>
            <div className="row mt-3">
                {
                    data.isCod == false && <div className="col-lg-4 col-sm-12">
                        <label>Department/CostCenter</label>
                        <input type="text" className="form-control" maxLength={50} value={data.departmentCostCenter} onInput={processStrWithSpace} onChange={(e) => updateData('departmentCostCenter', e.target.value)} />
                    </div>
                }
                <div className="col" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" disabled={loading} onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    </section >
}

export default RetailBooking;